<mat-form-field floatLabel="never" class="tw-w-full">
  <input
    [formControl]="control"
    class="tw-w-full"
    matInput
    [placeholder]="placeholder"
    type="text"
  />
  <mat-error>This field is required</mat-error>
  <mat-error *ngIf="control.hasError('validation')"
    >Seems like this field is invalid
  </mat-error>
</mat-form-field>
